<template>
  <thead>
    <tr class="order-table-summary-header sr-only">
      <th
        id="col-description"
        scope="col"
        class="order-table-summary__description"
      >
        Kostenart
      </th>
      <th
        id="col-amount"
        scope="col"
        class="order-table-summary__amount text--right"
      >
        Betrag
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'OrderTableSummaryHeader',
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-table-summary-header {
  font-size: 15px;
  line-height: 18px;
  align-items: end;
  border-bottom: 1px solid color(grey, 25000);

  th {
    font-weight: normal;
    text-align: inherit;
    padding-top: $grid-base;
    padding-bottom: $grid-base;
    vertical-align: bottom;
  }

  @include mq(false, $mq-md - 1) {
    display: none;
  }
}
</style>
